import React from 'react';
import './EventPhotoGrid.css';
import { Photo } from '../../../../types';
import { PhotoDisplayData } from '../../../../types/PhotoDisplayData';
import PhotoItem from './PhotoItem';
import { AddPhotoButton } from '../../../admin/AddPhotoButton';
import { useAdminStore } from '../../../../stores/useAdminStore';
import { useResponsiveDesign } from '../../../../hooks/useResponsiveDesign';

interface EventPhotoGridProps {
    images: Photo[];
    photoData?: PhotoDisplayData[]; // Admin data for unified operations
    eventName?: string; // Event name for admin operations
}

const EventPhotoGrid: React.FC<EventPhotoGridProps> = ({ images, photoData, eventName }) => {
    const isAdminMode = useAdminStore(s => s.isAdminMode);
    const { isMobile } = useResponsiveDesign();
    const totalPhotos = images.length;

    return (
        <div className="event-photo-grid-container">
            <div className="event-photo-grid">
                {images.map((img, idx) => {
                    const correspondingPhotoData = photoData?.find(pd => pd.url === img.url);

                    return (
                        <PhotoItem
                            key={idx}
                            photo={img}
                            photoData={correspondingPhotoData}
                            index={idx}
                            totalPhotos={totalPhotos}
                        />
                    );
                })}
                {isAdminMode && !isMobile && eventName && (
                    <AddPhotoButton eventName={eventName} />
                )}
            </div>
        </div>
    );
};

export default EventPhotoGrid;
